import React, { ReactElement } from 'react';
import { Text } from 'idsk-react-components';
import LegislativnyMaterialListRow from './LegislativnyMaterialListRow';
import './legislativnyMaterialListComponent.scss';
import LegislativnyMaterialFilterListPage
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialFilterListPage';

interface Props {
  legislativnyMaterialPage: LegislativnyMaterialFilterListPage;
  isSelectedFilter: boolean;
}

const LegislativnyMaterialListComponent = ({
  legislativnyMaterialPage,
  isSelectedFilter,
}: Props): ReactElement => {
  if (legislativnyMaterialPage.totalElements === 0 && isSelectedFilter) {
    return (
      <Text type="p" size="l" className="text-center">Nenašli sa žiadne procesy zodpovedajúce zvolenému filtru.</Text>
    );
  }

  if (legislativnyMaterialPage.totalElements === 0) {
    return <Text type="p" size="l" className="text-center">Neexistujú žiadne procesy.</Text>;
  }

  if (legislativnyMaterialPage.totalElements > 0 && legislativnyMaterialPage.materialList.length === 0) {
    return (
      <Text type="p" size="l" className="text-center">
        Na aktuálnej stránke sa nenachádzajú žiadne procesy.
      </Text>
    );
  }

  return (
    <>
      {legislativnyMaterialPage.materialList.map((material) => (
        <LegislativnyMaterialListRow legMaterial={material} key={material.cisloLp} />
      ))}
    </>
  );
};

export default LegislativnyMaterialListComponent;
